import React from "react";
import {
  Legend as StyledLegend,
  LegendHeader,
  LegendTitle,
  LegendCloseButton,
} from "./styled";

function Legend({ className, title, isOpen = true, onClose, children }) {
  return (
    <StyledLegend className={className} id="map-legend" $open={isOpen}>
      <LegendHeader>
        <LegendTitle>{title}</LegendTitle>
        <LegendCloseButton onClick={onClose} aria-label="Close legend">
          &times;
        </LegendCloseButton>
      </LegendHeader>
      <ul>{children}</ul>
    </StyledLegend>
  );
}

export default Legend;
